import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "status"]
  static values  = { url: String }

  connect() {
    this._original = this.inputTarget.value
  }

  handleKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.inputTarget.blur()
    } else if (event.key === "Escape") {
      this.inputTarget.value = this._original
      this.inputTarget.blur()
    }
  }

  handleBlur() {
    if (this.inputTarget.value === this._original) return
    this.save()
  }

  save() {
    const location = this.inputTarget.value.trim()
    const token    = document.querySelector("meta[name='csrf-token']")?.content

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        "Accept": "application/json"
      },
      body: JSON.stringify({ location })
    })
      .then(r => {
        if (r.ok) {
          this._original = this.inputTarget.value
          this.flash("saved")
        } else {
          this.flash("error")
        }
      })
      .catch(() => this.flash("error"))
  }

  flash(state) {
    if (!this.hasStatusTarget) return
    const el = this.statusTarget
    el.innerHTML = state === "saved"
      ? `<i class="bi bi-check-lg"></i>`
      : `<i class="bi bi-exclamation-lg"></i>`
    el.className   = state === "saved" ? "text-success small ms-1" : "text-danger small ms-1"
    el.style.opacity = "1"
    setTimeout(() => { el.style.opacity = "0" }, 1500)
  }
}
